'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loadmore = require('./loadmore');

var _loadmore2 = _interopRequireDefault(_loadmore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _loadmore2.default;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-weui/build/packages/components/loadmore/index.js
// module id = 398
// module chunks = 0